import api from '../axios.js'
import store from '../../store/index.js'

/**
 * Get Events
 * @param {Object} queryParams - Axios request parameters
 * @param {String} queryParams.campaign_key - key unique for each event
 * @param {"MetalGo" | "PosPayGold" | "NUNomics" | "BMTDigi"} queryParams.app_name - nama kemitran yang menjalankan campaign.
 * @param {"rped | gopay"} queryParams.payment_method - metode pembayaran yang aktif pada campaign.
 * @returns {Promise} - Axios response Promise
 */
export const getEvent = async (queryParams) => {
	return await api.get('/v2.1/public/campaigns', {
		params: {
			campaign_key: queryParams.campaign_key,
			app_name: queryParams.app_name || store.getters.getAppName,
			payment_method: queryParams.payment_method || store.getters.paymentMethod
		}
	})
}